import { useState, useEffect } from "react";// 1. On importe NavLink à la place de Link pour la navigation principale
import { NavLink, Link, useNavigate } from "react-router-dom";
import "../styles/Navbar.css"; 
import logo from "../images/logo-footvision-transparent.png";
import { useTheme } from "../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faHouse, faFutbol, faCrown, faUser, faSearch, 
  faSun, faMoon, faNewspaper, faBars, faXmark 
} from "@fortawesome/free-solid-svg-icons";

function Navbar() {
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const token = localStorage.getItem("token");

  const user =
  JSON.parse(
    localStorage.getItem("user")
    || "null"
  );

// 2. Ajoute ce bloc pour bloquer/débloquer le scroll du body
  useEffect(() => {
  // On s'assure que le body est clean au chargement/rafraîchissement
  if (isOpen) {
    document.body.style.overflow = "hidden";
    document.body.style.height = "100vh"; /* Bloque la hauteur du site */
  } else {
    document.body.style.overflow = "";
    document.body.style.height = "";
  }

  // Sécurité si l'utilisateur quitte la page ou rafraîchit sauvagement
  return () => {
    document.body.style.overflow = "";
    document.body.style.height = "";
  };
}, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar"> 
      {/* LOGO AREA */}
     <div className="navbar-logo" onClick={() => navigate("/")}>
        <img src={logo} alt="FootVision" className="site-logo" />
        <div className="symbo-logo">Live</div>
      </div>

      {/* BURGER BUTTON */}
      <button className="navbar-burger" onClick={toggleMenu} aria-label="Menu">
        <FontAwesomeIcon icon={isOpen ? faXmark : faBars} />
      </button>

      {/* LINKS AREA */}
      <div className={`navbar-links  ${isOpen ? "is-open" : ""}`}>
      <div className={`navbar-conteneur  ${isOpen ? "is-open" : ""}`}>


        {/* On utilise NavLink ici */}
        <NavLink to="/" end onClick={() => setIsOpen(false)}>
          <FontAwesomeIcon icon={faHouse} /> <span>Accueil</span>
        </NavLink>

        <NavLink to="/matches" onClick={() => setIsOpen(false)}>
          <FontAwesomeIcon icon={faFutbol} /> <span>Matchs</span>
        </NavLink>

        <NavLink to="/vip/compositions" onClick={() => setIsOpen(false)}>
          <FontAwesomeIcon icon={faNewspaper} /> <span>Compos</span>
        </NavLink>
{/*
        <NavLink to="/vip" onClick={() => setIsOpen(false)} className="link-vip">
          <FontAwesomeIcon icon={faCrown} /> <span>VIP</span>
        </NavLink>
*/}

        {/* Séparateur visuel optionnel ou fin de la navigation fixe */}
        <span className="nav-separator"></span>

        <button onClick={() => { toggleTheme(); setIsOpen(false); }} className="theme-toggle-btn">
          <FontAwesomeIcon icon={theme === "sombre" ? faSun : faMoon} />
          <span>{theme === "sombre" ? " Clair" : " Sombre"}</span>
        </button>
      
        <button onClick={() => { navigate("/matches/search"); setIsOpen(false); }} className="search-nav-btn">
          <FontAwesomeIcon icon={faSearch} /> <span>Recherche</span>
        </button>

        {token ? (
          <Link to="/profile" onClick={() => setIsOpen(false)}>
            <FontAwesomeIcon icon={faUser} /> <span>Profil</span>
          </Link>
        ) : (
          <div className="auth-buttons">
            <Link to="/login" onClick={() => setIsOpen(false)} className="btn-login">Connexion</Link>
            <Link to="/register" onClick={() => setIsOpen(false)} className="btn-register">Inscription</Link>
          </div>
        )}

        {user?.role === "admin" && (

  <Link
    to="/admin"
    onClick={() =>
      setIsOpen(false)
    }
  >

  Admin
  </Link>

)}
       </div>
     
      </div>
    </nav>
  );
}

export default Navbar;
